import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import {
  Component,
  DestroyRef,
  inject,
  LOCALE_ID,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { PrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';
import { ToastModule } from 'primeng/toast';
import { MetaService } from './core/api/v1/meta/meta.service';
import { CustomPreset } from './theme/theme';

registerLocaleData(localeIt, 'it');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterModule, ToastModule],
  providers: [{ provide: LOCALE_ID, useValue: 'it' }, DialogService],
})
export class AppComponent implements OnInit {
  private metaService = inject(MetaService);
  private translocoService = inject(TranslocoService);
  private destroyRef = inject(DestroyRef);

  title = 'wannacamp-booking-web';

  constructor(private config: PrimeNG) {
    // Il tema rimane nel costruttore, è indipendente dalla lingua
    this.config.theme.set({
      preset: CustomPreset,
      options: {
        darkModeSelector: 'false',
        cssLayer: {
          name: 'primeng',
          order: 'tailwind-base, primeng, tailwind-utilities',
        },
      },
    });
  }

  ngOnInit(): void {
    this.metaService.updateHomeSeo();

    this.translocoService
      .selectTranslateObject('primeng')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((translationObject) => {
        if (
          translationObject &&
          typeof translationObject === 'object' &&
          !Array.isArray(translationObject)
        ) {
          this.config.setTranslation(translationObject);
        } else {
          console.warn(
            'Attenzione: il blocco "primeng" non è stato trovato nel file JSON della lingua, o non è un oggetto.',
          );
        }
      });
  }
}
